import { render, staticRenderFns } from "./AboutResources.vue?vue&type=template&id=98fbf694&"
import script from "./AboutResources.vue?vue&type=script&lang=js&"
export * from "./AboutResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports